import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ReactComponent as IconExpand } from 'images/icon_expand.svg';
import { ReactComponent as IconCollapse } from 'images/icon_collapse.svg';
import styles from './index.module.scss';
import staticText from 'static/text_display.json';
import ButtonIcon from '../IconButton';
import { CreateIcon } from 'Icons';
import { useTranslation } from 'react-i18next';
import { IconButton, Paper, SvgIcon } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import { FORM } from 'utils/constants/css';
import { ReactComponent as EditIcon } from 'images/new/edit.svg';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: 0,
  },
  sectionBackground: {
    marginTop: '10px',
    textAlign: 'center',
    background: theme.palette.background.default,
  },
  summary: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    height: '45px', // This height will make sure that section remains same height even if there is no edit button
    background: theme.palette.background.paper,
    border: FORM.BORDER,
  },
  mySvgStyle: {
    height: '25px',
    width: '25px',
    cursor: 'pointer',
    '& [class*="st1"]': {
      fill: `${theme.palette.text.primary} !important`,
    },
    '& [class*="st0"]': {
      fill: `${theme.palette.text.primary} !important`,
    },
  },
}));

const WithTextTypography = withStyles(theme => ({
  root: {
    color: theme.palette.text.secondary,
  },
}))(Typography);

const Section = ({
  text,
  children,
  isConfirmPopup,
  className,
  expandable,
  editable,
  onEdit,
  addItem,
  onAdd,
  contentStyle,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(true);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const onClick = () => {
    if (expandable) {
      toggleExpanded();
    }
  };

  return (
    <Paper
      className={cn(
        styles.expansionPanel,
        className,
        classes.sectionBackground,
      )}
    >
      {!isConfirmPopup && ( // --------This is the header part of the section
        <div className={classes.summary} onClick={onClick}>
          <WithTextTypography>{t(text)}</WithTextTypography>

          {editable && (
            <SvgIcon className={classes.mySvgStyle} onClick={onEdit}>
              <EditIcon />
            </SvgIcon>
          )}
          {addItem && (
            <ButtonIcon
              noHorizontalPadding
              className={styles.icon}
              component={CreateIcon}
              onClick={onAdd}
              iconProps={{
                fontSize: 'inherit',
              }}
            />
          )}

          {expandable && (
            <IconButton
              color="primary"
              component="div"
              title={
                expanded
                  ? t(staticText.general.hide_section)
                  : t(staticText.general.show_section)
              }
            >
              <SvgIcon className={classes.mySvgStyle}>
                {expanded ? <IconCollapse /> : <IconExpand />}
              </SvgIcon>
            </IconButton>
          )}
        </div>
      )}
      <div //-------------------This is where all the input fields are rendered like general information, detail information
        className={cn(styles.content, {
          [styles.contentHidden]: !expanded,
        })}
      >
        <div className={cn(styles[`childContainer--${contentStyle}`])}>
          {children}
        </div>
      </div>
    </Paper>
  );
};

Section.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isConfirmPopup: PropTypes.bool,
  className: PropTypes.string,
  expandable: PropTypes.bool,
  editable: PropTypes.bool,
  onEdit: PropTypes.func,
  addItem: PropTypes.bool,
  onAdd: PropTypes.func,
  contentStyle: PropTypes.string,
  childClassName: PropTypes.string,
};

Section.defaultProps = {
  isConfirmPopup: false,
  expandable: true,
};

export default Section;
